
import { Prop, Vue, Component } from 'vue-property-decorator';
import SubcategoryItem from './SubcategoryItem.vue';

interface Category {
    name: string;
    subcategories?: Category[];
}

@Component({
    components: { SubcategoryItem }
})
export default class CategoryItem extends Vue {
    @Prop({ required: true }) readonly category!: Category;
    isOpen: boolean = false;

    toggle() {
        this.isOpen = !this.isOpen;
    }
}
